import React, { useEffect, useState } from 'react';
import { Icons, Images } from '../../assets';
import NotificationDropdown from '../../modalComponents/NotificationDropdown';
import ProfileDropdown from '../../modalComponents/ProfileDropdown';
import { gets3Url } from '../../service/helpers';
import { useSelector } from 'react-redux';
import { getNotificationList } from '../../redux/reducers/ccSlice';

const Navbar = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [profileURL, setProfileURL] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);
  const userData = useSelector((state) => state.auth.userData);

  const listPayload = {
    page: 1,
    limit: 20,
    userType: 'FIELD_OFFICER',
  };

  useEffect(() => {
    if (userData?.profilePic) {
      getUserProfilePic(userData?.profilePic);
    }
  }, [userData]);

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const response = await getNotificationList(listPayload);
      if (response?.data?.notifications) {
        const unread = response.data.notifications.filter(
          (notification) => !notification.isRead
        ).length;
        setUnreadCount(unread);
      }
    } catch (error) {
      console.error('Error fetching notification count:', error);
    }
  };

  const navigateToProfile = () => {
    setShowProfileDropdown(!showProfileDropdown);
  };

  const getUserProfilePic = async (profileKey) => {
    const profilePic = await gets3Url(null, profileKey);

    setProfileURL(profilePic);
  };

  const handleNotificationClick = () => {
    setShowNotification(!showNotification);
    if (!showNotification) {
      fetchUnreadCount();
    }
  };

  const handleNotificationClose = (isOpen) => {
    setShowNotification(isOpen);
    if (!isOpen) {
      setTimeout(fetchUnreadCount, 500);
    }
  };

  return (
    <>
      <div className={'relative h-navbar !shadow-nav'}>
        <div className={'h-full bg-white-color w-[100%] flex items-center justify-between'}>
          <div className={'w-sidebar'}>
            <img src={Icons.kgLogo} className={'h-[calc((60px-10px)/2)] mx-auto w-auto'} />
          </div>
          <div className={'mr-[26px] flex items-center'}>
            {/* {hasPermissionToViewNotifications && ( */}
            <div
              className={
                'mx-[5px] cursor-pointer w-[32px] h-[32px] rounded-full flex items-center justify-center relative'
              }
            >
              <img
                src={Icons.bellIcon}
                className={'h-[32px] w-auto'}
                onClick={handleNotificationClick}
              />
              {/* Notification Count Badge */}
              {unreadCount > 0 && (
                <div className='absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1'>
                  {unreadCount > 99 ? '99+' : unreadCount}
                </div>
              )}
            </div>
            {/* )} */}
            <div
              className={
                'mx-[5px] cursor-pointer  w-[36px] h-[36px] relative flex items-center justify-center'
              }
            >
              <div
                className='relative w-full h-full  flex items-center justify-center rounded-full cursor-pointer'
                onClick={() => navigateToProfile()}
              >
                {profileURL ? (
                  <img
                    src={profileURL}
                    alt='profile picture'
                    className={
                      'w-[90%] h-[90%] rounded-full z-[2] absolute border-2 border-[#b71c3f] top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] object-cover'
                    }
                  />
                ) : (
                  <span className='w-14 h-full rounded-full flex items-center justify-center text-black text-lg font-semibold shadow-custom'>
                    {userData?.name?.charAt(0)?.toUpperCase() || '?'}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>
          <img src={Images.colorBar} />
        </div>
      </div>
      {showNotification ? (
        <NotificationDropdown
          isOpen={showNotification}
          closePopUp={handleNotificationClose}
          notifymodal
          onCountUpdate={fetchUnreadCount}
        />
      ) : null}
      {showProfileDropdown ? (
        <ProfileDropdown
          isOpen={showProfileDropdown}
          closePopUp={setShowProfileDropdown}
          profileURL={profileURL}
          notifymodal
        />
      ) : null}
    </>
  );
};

export default Navbar;
